import React, { useEffect, useState } from 'react';
import UserFormComponent from '../../../../Components/AdminComponents/Users/UserForm';
import {
  addUsers,
  fetchUsersById,
  getAllChapters,
  getAllChaptersByQueryStringForSearch,
  getAllKeywordsByQuery,
  resetKeywordSearchData,
  updateUserByAdminId,
} from '../../../../Store/Actions';
import { useDispatch, useSelector } from 'react-redux';
import {
  appendOtherChapterOption,
  createSelectionOptionsUtil,
  createSelectionForAdminOptionsUtil,
  getVisibleChapters,
  queryString,
  resolveOtherChapter,
} from '../../../../Util/commonUtility';
import { useNavigate } from 'react-router-dom';
// import { getPbssInternationalById } from '../../../../Store/Actions/pbssInternational';

const UserFormContainer = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { fetchUserData } = useSelector(({ users }) => users);
  const { allChapters } = useSelector(({ chapters }) => chapters);
  const [editData, setEditData] = useState();
  const [chapterList, setChapterList] = useState([]);
  const [keywordsOptions, SetKeywordsOptions] = useState([]);
  const { allChaptersQueryData } = useSelector(({ chapters }) => chapters);
  const { allKeywordsQueryData } = useSelector(({ keywords }) => keywords);
  const [fetching, setFetching] = useState(false);
  const [otherChapterId, setOtherChapterId] = useState(null);
  // const { allPbssInternational } = useSelector(
  //   ({ pbssInternational }) => pbssInternational,
  // );
  // const [pbssInternationalData, setPbssInternationalData] = useState();

  // useEffect(() => {
  //   if (
  //     allPbssInternational &&
  //     allPbssInternational?.data?.pbssInternational &&
  //     allPbssInternational?.data?.pbssInternational.length > 0
  //   ) {
  //     setPbssInternationalData(allPbssInternational?.data?.pbssInternational[0]);
  //   }
  // }, [allPbssInternational]);

  const [chapterOptions, setChapterOptions] = useState();

  useEffect(() => {
    dispatch(resetKeywordSearchData(false));
  }, []);

  useEffect(() => {
    if (fetchUserData) {
      setEditData(fetchUserData?.data);
    }
  }, [fetchUserData]);

  useEffect(() => {
    if (allChaptersQueryData?.forSearch) {
      const chapters = allChaptersQueryData?.forSearch?.data?.chapters ?? [];
      const visibleChapters = getVisibleChapters(chapters);
      setChapterOptions(
        appendOtherChapterOption(
          createSelectionForAdminOptionsUtil(visibleChapters, 'id', 'name'),
          chapters,
        ),
      );
      setOtherChapterId(resolveOtherChapter(chapters)?.id ?? null);
      setFetching(false);
    } else {
      dispatch(
        getAllChaptersByQueryStringForSearch('', '', '', {
          page: 1,
          pageCount: 100,
        }),
      );
    }
  }, [allChaptersQueryData?.forSearch?.data?.chapters]);

  useEffect(() => {
    if (allKeywordsQueryData.forMaster) {
      SetKeywordsOptions(
        createSelectionOptionsUtil(
          allKeywordsQueryData.forMaster?.data?.keywords,
          'id',
          'name',
        ),
      );
    } else {
      dispatch(
        getAllKeywordsByQuery('name', 'ascend', queryString({ status: 1 }), {
          page: 1,
          pageCount: 1000,
        }),
      );
    }
  }, [allKeywordsQueryData.forMaster]);

  useEffect(() => {
    if (allChapters) {
      const chapters = allChapters?.data?.chapters ?? [];
      const visibleChapters = getVisibleChapters(chapters);
      setChapterList(
        createSelectionForAdminOptionsUtil(visibleChapters, 'id', 'name'),
      );
      setOtherChapterId((current) =>
        current ?? resolveOtherChapter(chapters)?.id ?? null,
      );
    } else {
      dispatch(getAllChapters());
    }
  }, [allChapters]);

  // useEffect(() => {
  //   if (allKeywords) {
  //     setKeywordsList(
  //       createSelectionOptionsUtil(allKeywords?.data?.keywords, 'name', 'name'),
  //     );
  //   } else {
  //     dispatch(getAllKeywords());
  //   }
  // }, [allKeywords]);

  const updateUser = async (Data, id) => {
    dispatch(updateUserByAdminId(Data, id, navigate));
  };

  const fetchUserById = async (id) => {
    dispatch(fetchUsersById(id));
  };
  const postUser = async (Data) => {
    dispatch(addUsers(Data, navigate));
  };

  //  useEffect(() => {
  //     fetchPbssInternationalById();
  //   }, []);
  
  //   const fetchPbssInternationalById = () => {
  //     dispatch(getPbssInternationalById());
  //   };

  return (
    <div>
      <UserFormComponent
        updateUser={(id, Data) => {
          updateUser(id, Data);
        }}
        fetchUserById={(id) => {
          fetchUserById(id);
        }}
        postUser={(Data) => {
          postUser(Data);
        }}
        editData={editData}
        // pbssInternationalData={pbssInternationalData}
        chaptersList={chapterList}
        chapterOptions={chapterOptions}
        otherChapterId={otherChapterId}
        setChapterOptions={setChapterOptions}
        keywordsOptions={keywordsOptions}
      />
    </div>
  );
};

export default UserFormContainer;
